<template>
  <div class="myteampay">
    <toptitle :title1="titlework" />
    <!-- 下拉项-->
    <section class="menu">
      <div @click="showPopup" class="choosedate">
        {{ deptSearch }}
      </div>
      <div
        style="border-left: 1px solid #e5e5e5;"
        @click="showPopup2"
        class="choosedate"
      >
        {{ dateSearch | datefmt }}
      </div>
      <!--部门选择-->
      <van-popup v-model="show" position="bottom">
        <van-picker
          v-model="deptSearch"
          show-toolbar
          title="请选择部门"
          :columns="columns"
          @confirm="onConfirm"
        />
      </van-popup>
      <!--日期选择 -->
      <van-popup v-model="show2" position="bottom">
        <van-datetime-picker
          v-model="dateSearch"
          type="year-month"
          title="选择年月"
          @confirm="onConfirm2"
          :min-date="dateSearchMinDate"
          :max-date="dateSearchMaxDate"
        />
      </van-popup>
    </section>
    <div class="circle-echart">
      <div class="pay-number">
        <div class="cost-num">
          <p>
            年度薪酬总额：<span>{{ costTotal.AMOUNT }} 元</span>
          </p>
        </div>
        <div class="cost-num">
          <p>
            年度累计薪酬支出总额：<span>{{ costTotal.PAY }} 元</span>
          </p>
        </div>
        <div class="cost-num">
          <p>
            年度薪酬剩余总额：<span>{{ costTotal.LAVE }} 元</span>
          </p>
        </div>
        <div class="cost-num">
          <p>
            年中增加总额：<span>{{ costTotal.MID_ADD }} 元</span>
          </p>
        </div>
      </div>

      <div class="btn-detail">
        <van-button round type="info" @click="gototeampaydetail"
          >查看详情</van-button
        >
      </div>
      <div class="echart-box">
        <echart-paybar
          id="echart1"
          :itemsData="costExpendData"
          titletop="当月薪酬总额（元）"
        ></echart-paybar>
      </div>
      <div class="echart-box">
        <echart-paybar
          id="echart2"
          :itemsData="paystandData"
          titletop="月标准工资（元）"
        ></echart-paybar>
      </div>
      <div class="echart-box">
        <echart-paybar
          id="echart3"
          :itemsData="costOvertimeData"
          titletop="月加班费（元）"
        ></echart-paybar>
      </div>
      <div class="echart-box">
        <echart-paybar
          id="echart4"
          :itemsData="allowanceData"
          titletop="津贴补贴项（元）"
        ></echart-paybar>
      </div>
      <!-- <div class="echart-box">
        <echart-paybar id="echart5"
                       :itemsData="otherIncomeData"
                       titletop="其他收入/扣减（元）"></echart-paybar>
      </div> -->
    </div>
    <loading-show :isLoadindShow="loading"></loading-show>
  </div>
</template>

<script>
  import toptitle from '../components/toptitle';
  import LoadingShow from '../components/loading';
  import dateformat from '@/utils/dateformat';
  import echartPaybar from '../components/analysisechart/echart-paybar';
  import echartLine from '../components/analysisechart/echart-line';

  import { getMyDeptDataApi, getMyteampayDataApi } from '../request/api';

  export default {
    name: 'teampay',
    data() {
      return {
        titlework: '团队薪酬情况',
        show: false,
        show2: false,
        loading: false,
        dateSearchMinDate: new Date(2010, 1, 1), //年月范围中的最小值定义
        dateSearchMaxDate: new Date(), //年月范围中可选的最大值定义，在 created 中动态设置为当前月份
        dateSearch: '',
        deptSearch: '部门',
        department: [],
        columns: [],
        columns2: [],
        costTotal: [],
        costExpendData: [], //当月薪酬总额
        paystandData: [], //月标准工资
        costOvertimeData: [], //月加班费
        allowanceData: [], //津贴补贴项
        otherIncomeData: [] //其他收入/扣减
      };
    },
    components: {
      toptitle,
      LoadingShow,
      echartPaybar,
      echartLine
    },

    mounted() {
      this.getDeptList();
    },
    methods: {
      showPopup() {
        this.show = true;
      },
      showPopup2() {
        this.show2 = true;
      },
      onConfirm(value) {
        this.deptSearch = value;
        this.show = false;
        this.getTeampayData();
      },
      onConfirm2(value) {
        this.dateSearch = value;
        this.show2 = false;
        this.getTeampayData();
      },
      onCancel() {
        this.show = false;
        this.show2 = false;
      },
      gototeampaydetail() {
        let departmentId = '';
        this.department.forEach(item => {
          if (this.deptSearch == item.DEPT_DESCR) {
            departmentId = item.DEPTID;
          }
        });
        // console.log(dateformat('yyyy-MM', this.dateSearch), 'this.deptSearch')
        this.$router.push({
          path: '/teampaymessage',
          query: {
            DEPTID: departmentId,
            CURR_DATE: dateformat('yyyy_MM', this.dateSearch)
          }
        });
      },
      /**
       * 部门获取
       * **/
      getDeptList() {
        let params = {
          EMPLID: sessionStorage.getItem('EMPLID')
        };
        getMyDeptDataApi(params).then(res => {
          if (res.CODE === 200) {
            this.department = res.DATA;

            this.columns = this.department.map(item => {
              return item.DEPT_DESCR;
            });
            if (this.deptSearch == '部门') {
              this.deptSearch = this.department[0].DEPT_DESCR;
            }
            this.getTeampayData();
          }
        });
      },

      //echart数据分析
      getTeampayData() {
        this.loading = true;
        let departmentId = '';

        this.department.forEach(item => {
          if (this.deptSearch == item.DEPT_DESCR) {
            departmentId = item.DEPTID;
          }
        });
        let params = {
          EMPLID: sessionStorage.getItem('EMPLID'),
          DEPTID: departmentId,
          DATE: dateformat('yyyy_MM', this.dateSearch)
        };

        getMyteampayDataApi(params).then(res => {
          if (res.CODE === 200) {
            this.costTotal = res.DATA;
            console.log(this.costTotal.PAY, 'res');
            //当月薪酬总额
            this.costExpendData = this.costTotal.PAYLIST.map(item => {
              return {
                value: item.VALUE,
                name: item.LABEL
              };
            });
            this.paystandData = this.costTotal.PAYSTAND.map(item => {
              return {
                value: item.VALUE,
                name: item.LABEL
              };
            });
            //加班费用支出分析
            // this.costOvertimeData = res.DATA.PAYOVER
            this.costOvertimeData = this.costTotal.PAYOVER.map(item => {
              return {
                value: item.VALUE,
                name: item.LABEL
              };
            });
            this.allowanceData = this.costTotal.PAYADD.map(item => {
              return {
                value: item.VALUE,
                name: item.LABEL
              };
            });
            this.otherIncomeData = this.costTotal.PAYOTHER.map(item => {
              return {
                value: item.VALUE,
                name: item.LABEL
              };
            });
            this.loading = false;
          }
        });
      }
    },
    filters: {
      million(value) {
        let num;
        if (value > 9999) {
          num = Math.floor(value / 1000) / 10 + '万';
        } else if (value < 9999 && value > -9999) {
          num = value;
        } else if (value < -9999) {
          num = -(Math.floor(Math.abs(value) / 1000) / 10) + '万';
        }
        return num;
      }
    },
    created() {
      //能选择的最大年月为当前月份
      this.dateSearchMaxDate = new Date(dateformat('yyyy-MM-01'));
      //默认为当前月份
      this.dateSearch = new Date(dateformat('yyyy-MM-01'));
    },
    filters: {
      datefmt(val) {
        //格式化日期查询条件的显示内容

        if (!val) return '';
        return dateformat('yyyy年MM月', new Date(val));
      }
    }
  };
</script>

<style lang="less" scoped>
  .menu {
    display: flex;
    border-top: 1px solid #e5e5e5;
    div {
      box-shadow: 0;
    }
    .choosedate {
      width: 50%;
      background: white;
      height: 48px;
      line-height: 48px;
      text-align: center;
      color: #323233;
      font-size: 14px;
      overflow: hidden;
    }
    .choosedate:after {
      display: inline-block;
      content: '';
      position: relative;
      top: 2px;
      margin-left: 3px;
      width: 0;
      height: 0;
      border: 5px solid transparent;
      border-top-color: #999;
    }
  }
  // .triangle {
  //   display: inline-block;
  //   position: relative;
  //   top: 2px;
  //   margin-left: 3px;
  //   width: 0;
  //   height: 0;
  //   border: 5px solid transparent;
  //   border-top-color: #999;
  // }

  /deep/.van-button {
    height: 35px;
  }
  .circle-echart {
    margin: 0 auto;
    .pay-number {
      padding: 5px;
      margin: 20px 5px;
      border-radius: 5px;
      background: #fff;
      padding-bottom: 20px;
      .cost-num {
        padding: 0.5rem 0;
        height: 0px;
        min-width: 78%;
        border-bottom: 30px solid #ec9314;
        border-right: 25px solid transparent;
        line-height: 45px;
      }
      .cost-num:nth-child(1) {
        border-bottom: 30px solid #007fc6;
      }
      .cost-num:nth-child(3) {
        border-bottom: 30px solid #007fc6;
      }
      // .cost-num:after {
      //   position: absolute;
      //   top: 0.5em;
      //   height: calc(100% - 1.5em);
      //   left: -0.7em;
      //   content: '';
      //   width: 0;
      //   border-left: solid #1989fa 1px;
      // }
      .cost-num p {
        font-size: 14px;
        color: #fff;
        padding-left: 5px;
      }
    }
    .btn-detail {
      width: 95%;
      margin: 0 auto;
      padding: 15px 0px;
      text-align: center;
      border-top: 1px solid #007fc6;
    }
  }
  .date-cond {
    div {
      text-align: center;
      line-height: 40px;
      position: relative;
      font-size: 13px;
    }
    .arrow-check::before {
      content: '';
      width: 5px;
      height: 5px;
      border: solid #666;
      border-width: 1px 0 0 1px;
      transform: translate(-50%, -50%) rotate(-45deg);
      position: absolute;
      left: 2%;
      top: 50%;
      margin: 0px -10px;
    }
    .arrow-check::after {
      content: '';
      width: 5px;
      height: 5px;
      border: solid #666;
      border-width: 1px 0 0 1px;
      transform: translate(-50%, -50%) rotate(135deg);
      position: absolute;
      right: -5%;
      top: 50%;
      margin: 0px -10px;
    }
  }
  .echart-box {
    width: 95%;
    margin: 0 auto;
    background: #fff;
    margin-bottom: 20px;
    border-radius: 5px;
  }
  .timeSelect {
    display: flex;
    justify-content: space-between;
    width: 85%;
    margin: 0 auto;
    border-top: 1px solid #e5e5e5;
  }
</style>
